exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n\n\n.GameMini{\n\tposition: relative;\n\tfloat : left;\n\n    margin-bottom: 0px;\n\t\n\n}\n.Separate{\n\tposition: relative;\n\tfloat : left;\n\twidth: 100%;\n    margin-bottom: 0px;\n\t\n\n}\n.GameMiniImageContainer{\n\tposition: relative;\n\tfloat : left;\n\t\n\twidth: 70%;\n\t\n    cursor: pointer;\n\t\n\n\tbackground-size: contain;\n}\n.GameMiniTextContainer{\n\tposition: relative;\n\tfloat : left;\n    width: 30%;\n\t\n\ttext-align:center;\n\t\n\tmargin-right : auto;\n\tmargin-left : auto;\n\tmargin-top : 50px;\n    cursor: pointer;\n\t\n\n\tbackground-size: contain;\n}\n.gameMiniLink{\n\tposition: relative;\n\tfloat : left;\n\t\n\tborder:0;\n\twidth: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./client/css/jeux.css
// module id = 84
// module chunks = 0